import { useEffect, useState } from 'react';
import { ref as dbRef, onValue } from 'firebase/database';
import { database } from '../config/firebase';

/**
 * useTestMode — sottoscrizione in tempo reale a platformSettings/testMode.
 *
 * Usato da:
 *  - App.js, per mostrare il banner "TEST MODE ATTIVA" su tutto il sito
 *  - StripePaymentForm.js, per scegliere la publishable key giusta
 *  - PlatformAdminPanel.js, per mostrare lo stato dell'interruttore
 *
 * Il nodo è a lettura pubblica (vedi database.rules.json) quindi funziona
 * anche per visitatori non autenticati — è corretto che chiunque veda se la
 * piattaforma è in modalità test, per sicurezza e trasparenza.
 */
export function useTestMode() {
  const [testMode, setTestMode] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const testModeRef = dbRef(database, 'platformSettings/testMode');
    const unsubscribe = onValue(testModeRef, (snap) => {
      setTestMode(snap.val() === true);
      setLoaded(true);
    }, () => {
      // Se la lettura fallisce per qualsiasi motivo, fail-safe: si assume
      // live (mai far credere che sia test quando non lo è, e viceversa
      // il fail-safe qui è comunque "live" perché è lo stato normale/atteso).
      setTestMode(false);
      setLoaded(true);
    });
    return () => unsubscribe();
  }, []);

  return { testMode, loaded };
}
